import { motion } from "framer-motion";

import NavList from "./NavList";

import { heightAnimation } from "@/utils/animations";

const Nav = ({ closeNav }: { closeNav: () => void }) => {
  return (
    <motion.nav
      animate="open"
      className="bg-primary overflow-hidden absolute z-50 -top-full w-full"
      exit="close"
      initial="initial"
      variants={heightAnimation}
    >
      <div className="container mx-auto h-full flex items-center justify-center">
        {/* NavList component handles the menu items with letter animations */}
        <NavList closeNav={closeNav} />
      </div>
    </motion.nav>
  );
};

export default Nav;
